import React, { ReactElement, CSSProperties } from 'react';
import { Layout as ReactGridLayout } from 'react-grid-layout';
import ResponsiveReactGridLayout from 'adapter/in/dashboards/components/generic/ReactGrid/ResponsiveReactGridLayout';
import { LayoutElementType } from 'domain/entity/layout';

export type GridLayouts = Record<string, GridLayoutElement[]>;
export type GridLayoutElement = ReactGridLayout & {
    maxHeight: number;
    minHeight: number;
    maxWidth: number;
    minWidth: number;
    type: LayoutElementType;
};

type ReactGridProps = {
    gridLayouts: GridLayouts;
    breakpoints: { [P: string]: number };
    columns: { [P: string]: number };
    backgroundStyle: CSSProperties;
    rowHeight: number;
    cellMargin: [number, number];
    containerWidth: number;
    onWidthChange: (newWidth: number) => void;
    onDrag?: ReactGridLayout.ItemCallback;
    onResize?: ReactGridLayout.ItemCallback;
    onDragStop?: ReactGridLayout.ItemCallback;
    onResizeStop?: ReactGridLayout.ItemCallback;
    onBreakpointChange?: (newBreakpoint: string) => void;
    onLayoutChange?: (currentLayout: GridLayoutElement[], allLayouts: GridLayouts) => void;
    children: ReactElement | ReactElement[];
};

const ReactGrid = (props: ReactGridProps): ReactElement => {
    const {
        gridLayouts,
        breakpoints,
        columns,
        backgroundStyle,
        rowHeight,
        cellMargin,
        containerWidth,
        onWidthChange,
        onDrag,
        onResize,
        onDragStop,
        onResizeStop,
        onBreakpointChange,
        onLayoutChange,
        children,
    } = props;

    return (
        <>
            {gridLayouts && (
                <ResponsiveReactGridLayout
                    layouts={gridLayouts}
                    margin={cellMargin}
                    cols={columns}
                    breakpoints={breakpoints}
                    rowHeight={rowHeight}
                    style={backgroundStyle}
                    onDrag={onDrag}
                    onResize={onResize}
                    onDragStop={onDragStop}
                    onResizeStop={onResizeStop}
                    onSize={(size) => onWidthChange(size!.width!)}
                    onWidthChange={onWidthChange}
                    containerWidth={containerWidth}
                    onBreakpointChange={onBreakpointChange}
                    onLayoutChange={onLayoutChange}
                    isBounded={false}
                    containerPadding={[0, 0]}
                    compactType={null}
                    useCSSTransforms
                    preventCollision
                >
                    {children}
                </ResponsiveReactGridLayout>
            )}
        </>
    );
};

export default ReactGrid;
